import { isLocalEnvironment } from '@/environment'

import { FOOD_COST_LANDING_PAGE, LANDING_DIRECT_CONVERSION_EXPERIMENT } from './constants'

export const PROD_APP_ORIGIN = 'https://app.oidotipi.com'
export const LOCAL_APP_ORIGIN = 'http://localhost:5174'

/** Production app origin. Prefer `resolveAppOrigin()` for runtime links. */
export const APP_ORIGIN = PROD_APP_ORIGIN

export function resolveAppOrigin(): string {
    const override = import.meta.env.VITE_APP_ORIGIN?.trim()
    if (override) {
        return override.replace(/\/$/, '')
    }
    if (isLocalEnvironment) {
        return LOCAL_APP_ORIGIN
    }
    return PROD_APP_ORIGIN
}

export type AppOutboundCta = 'pricing_cta' | 'hero_cta' | 'header_cta' | 'client_access' | 'post_lead_offer'

export type AppOutboundExperimentOptions = {
    leadId?: string
    /** ISO timestamp for the 24h intro deadline (landing → app handoff). */
    offerEndsAt?: string
    experiment?: string
    variant?: string
}

export function buildAppOutboundUrl(cta: AppOutboundCta, options?: AppOutboundExperimentOptions): string {
    const experiment = options?.experiment?.trim()
    const variant = options?.variant?.trim()
    const isDirectConversionTreatment = experiment === LANDING_DIRECT_CONVERSION_EXPERIMENT && variant === 'treatment'
    const path = cta === 'client_access' ? '/login' : isDirectConversionTreatment ? '/signup/google' : '/signup'
    const params = new URLSearchParams({
        utm_source: 'oidotipi.com',
        utm_medium: 'landing',
        utm_campaign: FOOD_COST_LANDING_PAGE,
        utm_content: cta,
        landing_page: FOOD_COST_LANDING_PAGE,
    })
    const leadId = options?.leadId?.trim()
    if (leadId) {
        params.set('leadId', leadId)
    }
    const offerEndsAt = options?.offerEndsAt?.trim()
    if (offerEndsAt) {
        params.set('offerEndsAt', offerEndsAt)
    }
    if (experiment && variant) {
        params.set('experiment', experiment)
        params.set('variant', variant)
    }
    return `${resolveAppOrigin()}${path}?${params.toString()}`
}
